module.exports = __webpack_public_path__ + "img/deposit_normal.f22063f1.svg";